-----<template>
<div class="testqs" style="position: absolute; top: 10px; left: 10px; right: 10px; bottom: 10px">
  <a class="close" href="" v-on:click.prevent="$emit('close2')">&times;</a>
  <div class="done passed" v-if="current==group.questions.length && passed">
    <p>Congratulations! You have passed this test.</p>
  </div>
  <div class="done not-passed" v-else-if="current==group.questions.length">
    <p>Unfortunately, you have not passed this test. You will need to try again. Please contact <a style="font-weight: bold; text-decoration: underline; color: #1c49ed;" href="mailto:bodytech@me.com?cc=ivamazzoleni@hotmail.com">support</a> to be granted access once more.</p>
  </div>
  <div :class="{'password-prompt': passwordUsed}" v-else-if="current==-1">
<!--     <input type="text" placeholder="Please enter the password" v-model="password" /> -->
<!--     <p class="error" v-if="passwordFail">Incorrect password, please try again.</p> -->
    <p class="error" v-if="passwordUsed">You have already taken this test.</p>
  </div>
  <div class="qs" v-else>
    <h1>{{ item.parent?item.parent.subtitle:item.subtitle }} {{ item.title }}</h1>
    <h2>Please answer these questions:</h2>
    <h3>Question {{ current+1 }} of {{ group && group.questions.length }}</h3>
    <div class="question" v-if="question">
      <h4>{{ question.text }}</h4>
      <ul class="answers">
        <li v-for="(answer, ai) in question.answers">
          <label>
            <input type="checkbox" v-model="answers" :value="ai" />
            {{ answer.text }}
          </label>
        </li>
      </ul>
      <div class="answered correct" v-if="isAnswered===true">
        You answered correctly.
      </div>
      <div class="answered incorrect" v-if="isAnswered===false">
        You did not answer correctly.
      </div>
    </div>
  </div>
  <div class="" v-if="current==-1">
    <p>If you are ready to take your test or homework now, press START. Be aware that once you pressed "start" you will need to fully complete it to validate your completion.</p>
  </div>
  <div class="actions" v-if="current==-1">
    <button v-on:click.prevent="checkPassword">Start</button>
  </div>
  <div class="actions" v-else-if="current<group.questions.length">
    <button v-if="question && isAnswered===null" v-on:click.prevent="next">Submit</button>
    <button v-else-if="question && current<=group.questions.length-1" v-on:click.prevent="next">Next</button>
    <button v-else-if="question" v-on:click.prevent="next">Finish</button>
  </div>
  <div class="actions" v-else>
    <button v-on:click.prevent="doClose">Close</button>
<!--     <button v-if="!passed" v-on:click.prevent="$emit('again')">Try again</button> -->
  </div>
</div>
</template>

<script>
export default {
  props: ["item", "group", "index"],
  computed: {
    question() {
      if (!this.group)
        return null;
      return this.group.questions[this.current];
    },
    passed() {
      if (!this.group)
        return true;
      return this.group.passingScore<=this.complete;
    },
  },
  methods: {
    next() {
      if (!this.question)
        return;
      if (this.isAnswered===null) {
        var incorrect=false;
        for(var i in this.question.answers) {
          var valid=this.question.answers[i].valid;
          var selected=this.answers.indexOf(i*1)!=-1;
          console.log(i, valid, selected);
          if ((valid && !selected) || (valid && !selected))
            incorrect=true;
        }
        this.isAnswered=!incorrect;
        if (this.isAnswered)
          this.complete++;
        
      } else {
        this.isAnswered=null;
        this.oldAnswers.push(this.answers);
        this.answers=[];
        this.current++;
        if (this.takeId) {
          api.update("TestUser", this.takeId, {progress: {answers: this.oldAnswers}});
        }
      }
    },
    async doClose() {
      await api.create("TestTake", {
        video: this.item.id,
        user: appRoot.loggedIn.id,
        result: this.complete,
        answers: {
          index: this.index || 0,
          answers: this.oldAnswers,
          questions: this.group,
        },
        passed: this.passed?1:0,
        created: "CURRENT_TIMESTAMP",
        spenttime: 0,
      });
      if (this.passed)
        this.$emit('close');
      else
        this.$emit('close2');
    },
    async checkPassword() {
      if (false && (this.item.password || "").toLowerCase()!=(this.password.toLowerCase())) {
        this.passwordFail=true;
      } else {
        var takeItem=(await api.list("TestUser", {testid: this.item.id, userid: appRoot.loggedIn.id}, ["id:DESC"])).items[0];
        if (takeItem) {
          if (this.item.password=="homework" && ((takeItem.progress || {}).answers || []).length>=this.group.questions.length)
            takeItem=null;
        }
        if (takeItem && !takeItem.progress && ((takeItem.progress || {}).answers || []).length!=this.group.questions.length) {
//           this.passwordUsed=true;
          this.current=0;
          this.takeId=takeItem.id;
        } else if (takeItem) {
          this.oldAnswers=(takeItem.progress || {}).answers || [];
          this.current=this.oldAnswers.length;
          this.takeId=takeItem.id;
        } else {
          this.current++;
          var result=await api.create("TestUser", {video: this.item.id, user: appRoot.loggedIn.id});
          this.takeId=result.id;
        }
      }
    },
  },
  data: ()=>({
    current: 0,
    complete: 0,
    isAnswered: null,
    answers: [],
    oldAnswers: [],
    password: "",
    passwordFail: false,
    passwordUsed: false,
    takeId: null,
  }),
  mounted() {
    if (this.item.password)
      this.current=-1;
  },
}
</script>
